<div id="{{infoLabelsId}}">
  <div class="box-wrapper" *ngFor="let item of items">
    <div class="box-border-bottom">
      <div class="info-padding">
        <div title="{{item.value}}" class="device-info-info {{item.labelStyle}}">{{item.value || "0"}}</div>
        <div class="device-info-field {{item.labelStyle}}">{{item.field}}</div>
      </div>
    </div>
  </div>
</div>
